import { render } from "./BookViewTestimonials.vue?vue&type=template&id=a1ce5392&scoped=true"
import script from "./BookViewTestimonials.vue?vue&type=script&lang=js"
export * from "./BookViewTestimonials.vue?vue&type=script&lang=js"

import "./BookViewTestimonials.vue?vue&type=style&index=0&id=a1ce5392&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1ce5392"

export default script